export default __webpack_public_path__ + "static/media/MoroccoImg1.06151270.jpg";